import { Badge, Card, Modal, statusColor, COMM_CATEGORY_COLOR, COMM_PRIORITY_COLOR, COMM_PRIORITY_LABEL, btnPrimary, btnSecondary, btnDanger, inputStyle, labelStyle } from "./shared";

export default function Tenants({
  tenants, payments, communications, tenantPhotos,
  searchTenant, setSearchTenant,
  selectedTenant, setSelectedTenant,
  can, setPage,
  showAddTenant, setShowAddTenant,
  newTenant, setNewTenant, addTenant,
  editTenant, setEditTenant, saveTenantEdit,
  deleteTenant,
  showTenantHistory, setShowTenantHistory,
  photoType, setPhotoType,
  photoLabel, setPhotoLabel,
  photoUploadFile, setPhotoUploadFile,
  photoUploading, uploadTenantPhoto, deleteTenantPhoto,
  setShowCommLog, setNewComm, setShowAddComm,
}) {
  return (
    <>
      {/* TENANTS LIST */}
      {!selectedTenant && (
        <>
          <div className="app-page-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
            <div>
              <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600, fontSize: 32, color: "#2B2B2B", margin: 0 }}>Tenants</h1>
              <div style={{ color: "#9B9690", marginTop: 4, fontSize: 14 }}>{tenants.length} tenants</div>
            </div>
            {can.addTenant && <button style={btnPrimary} onClick={() => setShowAddTenant(true)}>+ Add Tenant</button>}
          </div>
          <input type="text" placeholder="🔍  Search by name, address, or unit..." value={searchTenant} onChange={e => setSearchTenant(e.target.value)} className="app-search" style={{ ...inputStyle, marginBottom: 20, maxWidth: 420 }} />
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {tenants.filter(t => !searchTenant || t.name?.toLowerCase().includes(searchTenant.toLowerCase()) || t.address?.toLowerCase().includes(searchTenant.toLowerCase()) || t.property?.toLowerCase().includes(searchTenant.toLowerCase())).map((t, idx) => (
              <Card key={idx}>
                <div className="app-tenant-row" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                  <div style={{ display: "flex", gap: 16, alignItems: "center", cursor: "pointer" }} onClick={() => setSelectedTenant(t)}>
                    <div style={{ width: 44, height: 44, borderRadius: "50%", background: "#163C2F", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontFamily: "'Cormorant Garamond', serif", fontSize: 16, color: "#fff", flexShrink: 0 }}>
                      {t.name?.split(" ").map(w => w[0]).join("").slice(0, 2) || "?"}
                    </div>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                        <span style={{ fontWeight: 700, fontSize: 16 }}>{t.name}</span>
                        {t.is_complimentary && <Badge label="Complimentary" color="#22c55e" />}
                        {t.tenant_type === "non_paying" && (
                          <Badge label={t.non_paying_subtype === "rent_free" ? "Rent-Free" : "Expense-Only"} color={t.non_paying_subtype === "rent_free" ? "#10b981" : "#f59e0b"} />
                        )}
                      </div>
                      <div style={{ fontSize: 13, color: "#9B9690" }}>{t.address}{t.city ? ", " + t.city : ""} {t.property ? "· " + t.property : ""}</div>
                    </div>
                  </div>
                  <div className="app-tenant-actions" style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", justifyContent: "flex-end" }}>
                    <div style={{ textAlign: "right", marginRight: 4 }}>
                      {t.tenant_type === "non_paying" ? (
                        <div style={{ marginBottom: 2 }}>
                          <Badge label={t.non_paying_subtype === "rent_free" ? "Rent-Free" : "Expense-Only"} color={t.non_paying_subtype === "rent_free" ? "#10b981" : "#f59e0b"} />
                        </div>
                      ) : (
                        <div style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15 }}>${t.rent?.toLocaleString()}/mo</div>
                      )}
                      <div style={{ fontSize: 12, color: "#9B9690" }}>{t.lease_end ? `Ends ${t.lease_end}` : "Month-to-Month"}</div>
                    </div>
                    <Badge label={t.status || "active"} color={statusColor[t.status] || "#22c55e"} />
                    <button onClick={() => setSelectedTenant(t)} style={{ ...btnPrimary, fontSize: 12, padding: "6px 14px" }}>View Profile →</button>
                    {can.editTenant && <button onClick={() => setEditTenant({ ...t })} style={{ ...btnSecondary, fontSize: 12, padding: "6px 12px" }}>✏️ Edit</button>}
                    {can.deleteTenant && <button onClick={() => deleteTenant(t)} style={btnDanger}>🗑</button>}
                  </div>
                </div>
                <div className="app-grid-4" style={{ marginTop: 14, paddingTop: 14, borderTop: "1px solid #e0dbd0", display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 12 }}>
                  {[["Phone", t.phone], ["Email", t.email], ["Property Type", t.property_type], ["Lease Start", t.lease_start], ["Lease End", t.lease_end || "Month-to-Month"], ["Zip", t.zip], ["State", t.state], ["Monthly Rent", t.tenant_type === "non_paying" ? (t.non_paying_subtype === "rent_free" ? "Rent-Free" : "Expense-Only") : `$${t.rent?.toLocaleString()}`]].map(([k, v]) => (
                    <div key={k}><div style={{ fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.07em" }}>{k}</div><div style={{ fontWeight: 600, marginTop: 2, fontSize: 13 }}>{v || "—"}</div></div>
                  ))}
                </div>
                {t.notes && <div style={{ marginTop: 12, padding: "10px 14px", background: "#F5F1EA", borderRadius: 8, fontSize: 13, color: "#9B9690", fontStyle: "italic" }}>📝 {t.notes}</div>}
              </Card>
            ))}
          </div>
        </>
      )}

      {/* TENANT DETAIL */}
      {selectedTenant && (() => {
        const st = selectedTenant;
        const tPays = payments.filter(p => p.tenant === st.name);
        const tComms = communications.filter(c => c.tenant === st.name);
        const rentPaid = tPays.filter(p => p.status === "paid").reduce((s, p) => s + (p.amount || 0), 0);
        const lateFees = tPays.reduce((s, p) => s + (p.late_fee || 0), 0);
        const overdues = tPays.filter(p => p.status === "overdue");
        const today = new Date();
        const daysLeft = st.lease_end ? Math.max(0, Math.ceil((new Date(st.lease_end) - today) / 86400000)) : null;
        const initials = st.name?.split(" ").map(w => w[0]).join("").slice(0, 2).toUpperCase() || "?";
        const currentPay = tPays.find(p => { const m = `${today.getFullYear()}-${String(today.getMonth()+1).padStart(2,"0")}`; return p.due && p.due.startsWith(m); });
        const thLbl = { fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.07em", fontWeight: 500 };
        const stPhotos = tenantPhotos.filter(ph => ph.tenant === st.name);
        const moveInPhotos = stPhotos.filter(ph => ph.photo_type === "move_in");
        const moveOutPhotos = stPhotos.filter(ph => ph.photo_type === "move_out");
        return (
          <>
            {/* Back bar */}
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 24 }}>
              <button onClick={() => setSelectedTenant(null)} style={{ ...btnSecondary, display: "flex", alignItems: "center", gap: 6 }}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
                All Tenants
              </button>
              <div style={{ display: "flex", gap: 8 }}>
                {can.editTenant && <button onClick={() => setEditTenant({ ...st })} style={{ ...btnSecondary, fontSize: 13 }}>✏️ Edit</button>}
                {can.deleteTenant && <button onClick={() => { deleteTenant(st); setSelectedTenant(null); }} style={btnDanger}>🗑 Delete</button>}
              </div>
            </div>

            {/* Header card */}
            <Card style={{ marginBottom: 20 }}>
              <div style={{ display: "flex", gap: 20, alignItems: "flex-start", flexWrap: "wrap" }}>
                <div style={{ width: 72, height: 72, borderRadius: "50%", background: "#163C2F", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 800, fontFamily: "'Cormorant Garamond', serif", fontSize: 26, color: "#fff", flexShrink: 0, letterSpacing: "-0.02em" }}>
                  {initials}
                </div>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", marginBottom: 6 }}>
                    <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 24, color: "#163C2F", margin: 0 }}>{st.name}</h2>
                    <Badge label={st.status || "active"} color={statusColor[st.status] || "#22c55e"} />
                    {st.is_complimentary && <Badge label="Complimentary" color="#22c55e" />}
                    {st.tenant_type === "non_paying" && (
                      <Badge label={st.non_paying_subtype === "rent_free" ? "Rent-Free" : "Expense-Only"} color={st.non_paying_subtype === "rent_free" ? "#10b981" : "#f59e0b"} />
                    )}
                  </div>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 20px", fontSize: 14, color: "#2B2B2B" }}>
                    {st.phone && <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9B9690" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 10.8 19.79 19.79 0 01.01 2.2 2 2 0 012 .01h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 14.92z"/></svg>
                      <a href={`tel:${st.phone}`} style={{ color: "#163C2F", textDecoration: "none" }}>{st.phone}</a>
                    </span>}
                    {st.email && <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9B9690" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
                      <a href={`mailto:${st.email}`} style={{ color: "#163C2F", textDecoration: "none" }}>{st.email}</a>
                    </span>}
                    {st.lease_start && <span style={{ display: "flex", alignItems: "center", gap: 5 }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#9B9690" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                      <span style={{ color: "#9B9690" }}>Tenant since</span> <strong>{st.lease_start}</strong>
                    </span>}
                  </div>
                  {st.notes && <div style={{ marginTop: 10, padding: "8px 12px", background: "#F5F1EA", borderRadius: 8, fontSize: 13, color: "#9B9690", fontStyle: "italic" }}>📝 {st.notes}</div>}
                  {st.is_complimentary && st.complimentary_notes && <div style={{ marginTop: 8, padding: "8px 12px", background: "#eef7f1", borderRadius: 8, fontSize: 13, color: "#214D3A", fontStyle: "italic" }}>🏡 {st.complimentary_notes}</div>}
                  {st.tenant_type === "non_paying" && st.non_paying_subtype === "expense_only" && st.expense_notes && (
                    <div style={{ marginTop: 8, padding: "8px 12px", background: "#fff8e1", borderRadius: 8, fontSize: 13, color: "#92400e", fontStyle: "italic" }}>💰 {st.expense_notes}</div>
                  )}
                </div>
              </div>
            </Card>

            {/* Lease + Payment row */}
            <div className="app-grid-2" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
              <Card>
                <div style={{ fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>Current Lease</div>
                {st.tenant_type === "non_paying" ? (
                  <div style={{ marginBottom: 8 }}>
                    <Badge label={st.non_paying_subtype === "rent_free" ? "Rent-Free" : "Expense-Only"} color={st.non_paying_subtype === "rent_free" ? "#10b981" : "#f59e0b"} />
                    {st.non_paying_subtype === "expense_only" && st.expense_notes && (
                      <div style={{ marginTop: 6, fontSize: 12, color: "#9B9690", fontStyle: "italic" }}>{st.expense_notes}</div>
                    )}
                  </div>
                ) : (
                  <div style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 800, fontSize: 22, color: "#163C2F", marginBottom: 4 }}>${st.rent?.toLocaleString()}<span style={{ fontSize: 14, fontFamily: "'Manrope', sans-serif", fontWeight: 400, color: "#9B9690" }}>/mo</span></div>
                )}
                <div style={{ fontSize: 14, color: "#2B2B2B", marginBottom: 12 }}>
                  {[st.address, st.city, st.state, st.zip].filter(Boolean).join(", ")}
                  {st.property && <span style={{ color: "#9B9690" }}> · {st.property}</span>}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6, marginBottom: 14 }}>
                  {[["Lease Start", st.lease_start || "—"], ["Lease End", st.lease_end || "Month-to-Month"], ["Type", st.property_type || "—"]].map(([k, v]) => (
                    <div key={k} style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                      <span style={{ color: "#9B9690" }}>{k}</span>
                      <span style={{ fontWeight: 600, color: "#163C2F" }}>{v}</span>
                    </div>
                  ))}
                  {daysLeft !== null && (
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 13 }}>
                      <span style={{ color: "#9B9690" }}>Days Remaining</span>
                      <span style={{ fontWeight: 700, color: daysLeft < 30 ? "#ef4444" : daysLeft < 60 ? "#f59e0b" : "#22c55e" }}>{daysLeft} days</span>
                    </div>
                  )}
                </div>
                <button onClick={() => setPage("Documents")} style={{ ...btnSecondary, fontSize: 12, width: "100%", textAlign: "center" }}>📄 View Lease Documents</button>
              </Card>

              <Card>
                <div style={{ fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>Payment Summary</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 16 }}>
                  {[["Rent Collected", `$${rentPaid.toLocaleString()}`], ["Late Fees", `$${lateFees.toLocaleString()}`], ["Grand Total", `$${(rentPaid + lateFees).toLocaleString()}`]].map(([k, v], i) => (
                    <div key={k} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: i === 2 ? 15 : 13, borderTop: i === 2 ? "1px solid #e0dbd0" : "none", paddingTop: i === 2 ? 8 : 0, marginTop: i === 2 ? 4 : 0 }}>
                      <span style={{ color: i === 2 ? "#163C2F" : "#9B9690", fontWeight: i === 2 ? 700 : 400 }}>{k}</span>
                      <span style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700, color: i === 2 ? "#163C2F" : "#163C2F" }}>{v}</span>
                    </div>
                  ))}
                </div>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, fontSize: 13 }}>
                  <span style={{ color: "#9B9690" }}>This Month</span>
                  {currentPay ? <Badge label={currentPay.status} color={statusColor[currentPay.status] || "#6b7280"} /> : <span style={{ color: "#9B9690", fontStyle: "italic", fontSize: 12 }}>No record</span>}
                </div>
                {overdues.length > 0 && (
                  <div style={{ background: "#fef2f2", border: "1px solid #fca5a5", borderRadius: 8, padding: "10px 12px" }}>
                    <div style={{ fontWeight: 700, color: "#ef4444", fontSize: 13, marginBottom: 4 }}>⚠ {overdues.length} Overdue Invoice{overdues.length > 1 ? "s" : ""}</div>
                    {overdues.map((p, i) => (
                      <div key={i} style={{ fontSize: 12, color: "#b91c1c", display: "flex", justifyContent: "space-between" }}>
                        <span>{p.due || "Unknown due date"}</span>
                        <span style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700 }}>${p.amount?.toLocaleString()}</span>
                      </div>
                    ))}
                  </div>
                )}
              </Card>
            </div>

            {/* Message History */}
            <Card style={{ marginBottom: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                <div style={{ fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em" }}>Message History</div>
                {can.addComm && <button onClick={() => { setShowCommLog(st); setNewComm(s => ({ ...s, tenant: st.name })); setShowAddComm(true); }} style={{ ...btnPrimary, fontSize: 12, padding: "6px 12px" }}>+ Log Message</button>}
              </div>
              {tComms.length === 0 ? (
                <div style={{ color: "#9B9690", fontSize: 13, textAlign: "center", padding: "24px 0" }}>No messages logged for this tenant yet.</div>
              ) : (
                <div className="app-table-scroll">
                  <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 480 }}>
                    <thead>
                      <tr style={{ borderBottom: "1px solid #e0dbd0" }}>
                        {["Type", "Subject", "Date", "Priority"].map(h => <th key={h} style={{ ...thLbl, padding: "8px 12px", textAlign: "left" }}>{h}</th>)}
                      </tr>
                    </thead>
                    <tbody>
                      {tComms.map((c, i) => (
                        <tr key={i} style={{ borderBottom: "1px solid #F0EDE6" }}>
                          <td style={{ padding: "10px 12px" }}><Badge label={c.type || "—"} color={COMM_CATEGORY_COLOR[c.type] || "#6b7280"} /></td>
                          <td style={{ padding: "10px 12px", fontSize: 13, fontWeight: 600, color: "#163C2F", maxWidth: 240 }}>{c.subject || "—"}</td>
                          <td style={{ padding: "10px 12px", fontSize: 12, color: "#9B9690" }}>{c.date || (c.created_at ? new Date(c.created_at).toLocaleDateString() : "—")}</td>
                          <td style={{ padding: "10px 12px" }}><Badge label={COMM_PRIORITY_LABEL[c.priority] || c.priority || "—"} color={COMM_PRIORITY_COLOR[c.priority] || "#6b7280"} /></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </Card>

            {/* Lease History */}
            <Card>
              <div style={{ fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 16 }}>Lease History</div>
              <div className="app-table-scroll">
                <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 400 }}>
                  <thead>
                    <tr style={{ borderBottom: "1px solid #e0dbd0" }}>
                      {["Monthly Rent", "Start Date", "End Date", "Days Remaining"].map(h => <th key={h} style={{ ...thLbl, padding: "8px 12px", textAlign: "left" }}>{h}</th>)}
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={{ padding: "12px 12px" }}>
                        {st.tenant_type === "non_paying"
                          ? <Badge label={st.non_paying_subtype === "rent_free" ? "Rent-Free" : "Expense-Only"} color={st.non_paying_subtype === "rent_free" ? "#10b981" : "#f59e0b"} />
                          : <span style={{ fontFamily: "'Manrope', sans-serif", fontWeight: 700, fontSize: 15 }}>${st.rent?.toLocaleString()}/mo</span>}
                      </td>
                      <td style={{ padding: "12px 12px", fontSize: 13, color: "#163C2F" }}>{st.lease_start || "—"}</td>
                      <td style={{ padding: "12px 12px", fontSize: 13, color: "#163C2F" }}>{st.lease_end || "Month-to-Month"}</td>
                      <td style={{ padding: "12px 12px" }}>
                        {daysLeft !== null
                          ? <span style={{ fontWeight: 700, color: daysLeft < 30 ? "#ef4444" : daysLeft < 60 ? "#f59e0b" : "#22c55e" }}>{daysLeft} days</span>
                          : <span style={{ color: "#9B9690", fontStyle: "italic" }}>Month-to-Month</span>}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </Card>

            {/* Move-In / Move-Out Photos */}
            <Card style={{ marginTop: 20 }}>
              <div style={{ fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 16 }}>Move-In / Move-Out Photos</div>
              <div style={{ background: "#F5F1EA", borderRadius: 10, padding: "14px 16px", marginBottom: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: "#163C2F", marginBottom: 10 }}>Upload Photo</div>
                <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "flex-end" }}>
                  <div>
                    <label style={labelStyle}>Type</label>
                    <select value={photoType} onChange={e => setPhotoType(e.target.value)} style={{ ...inputStyle, maxWidth: 140 }}>
                      <option value="move_in">Move-In</option>
                      <option value="move_out">Move-Out</option>
                    </select>
                  </div>
                  <div style={{ flex: 1, minWidth: 180 }}>
                    <label style={labelStyle}>Label (optional)</label>
                    <input type="text" value={photoLabel} onChange={e => setPhotoLabel(e.target.value)} placeholder="e.g. Kitchen, Bedroom" style={inputStyle} />
                  </div>
                  <div style={{ flex: 2, minWidth: 200 }}>
                    <label style={labelStyle}>Photo File</label>
                    <input type="file" accept="image/*" onChange={e => setPhotoUploadFile(e.target.files[0] || null)} style={{ ...inputStyle, paddingTop: 7 }} />
                  </div>
                  <button onClick={() => uploadTenantPhoto(st.name)} disabled={!photoUploadFile || photoUploading} style={{ ...btnPrimary, opacity: (!photoUploadFile || photoUploading) ? 0.5 : 1, whiteSpace: "nowrap" }}>
                    {photoUploading ? "Uploading…" : "Upload"}
                  </button>
                </div>
              </div>
              {stPhotos.length === 0 && (
                <div style={{ textAlign: "center", padding: "20px 0", color: "#9B9690", fontSize: 13 }}>No photos uploaded yet.</div>
              )}
              {[["move_in", "🟢 Move-In", "#22c55e"], ["move_out", "🟡 Move-Out", "#f59e0b"]].map(([type, label, color]) => {
                const photos = type === "move_in" ? moveInPhotos : moveOutPhotos;
                if (photos.length === 0) return null;
                return (
                  <div key={type} style={{ marginBottom: 16 }}>
                    <div style={{ fontSize: 12, fontWeight: 700, color, marginBottom: 8, textTransform: "uppercase", letterSpacing: "0.07em" }}>{label}</div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))", gap: 10 }}>
                      {photos.map((ph, i) => (
                        <div key={i} style={{ position: "relative", borderRadius: 8, overflow: "hidden", border: "1px solid #e0dbd0" }}>
                          <img src={ph.photo_url} alt={ph.label || type} style={{ width: "100%", height: 110, objectFit: "cover", display: "block" }} />
                          {ph.label && <div style={{ fontSize: 11, color: "#163C2F", background: "#FFFFFF", padding: "4px 8px", fontWeight: 500 }}>{ph.label}</div>}
                          <button onClick={() => deleteTenantPhoto(ph.id, ph.photo_url)} style={{ position: "absolute", top: 4, right: 4, background: "rgba(239,68,68,0.8)", border: "none", borderRadius: 4, color: "#fff", cursor: "pointer", fontSize: 11, padding: "2px 6px" }}>✕</button>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}
            </Card>
          </>
        );
      })()}

      {/* Add Tenant Modal */}
      {showAddTenant && (
        <Modal title="Add Tenant" onClose={() => setShowAddTenant(false)} onSave={addTenant}>
          {[["Full Name", "name", "text", ""], ["Address", "address", "text", "e.g. 4521 Oak Street"], ["City", "city", "text", ""], ["State", "state", "text", ""], ["Zip", "zip", "text", ""], ["Unit/Property Label", "property", "text", "e.g. Unit 1 (leave blank for house)"], ["Email", "email", "email", ""], ["Phone", "phone", "text", ""], ["Lease Start", "lease_start", "date", ""], ["Monthly Rent ($)", "rent", "number", ""]].map(([label, key, type, ph]) => (
            <div key={key}>
              <label style={labelStyle}>{label}</label>
              <input type={type} placeholder={ph} value={newTenant[key]} onChange={e => setNewTenant(s => ({ ...s, [key]: e.target.value }))} style={inputStyle} />
            </div>
          ))}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
            <div>
              <label style={labelStyle}>Lease End — leave blank for month-to-month</label>
              <input type="date" value={newTenant.lease_end} onChange={e => setNewTenant(s => ({ ...s, lease_end: e.target.value }))} style={inputStyle} />
            </div>
            <div>
              <label style={labelStyle}>Rent Due Day of Month</label>
              <input type="number" min="1" max="28" value={newTenant.due_day} onChange={e => setNewTenant(s => ({ ...s, due_day: e.target.value }))} style={inputStyle} placeholder="1" />
            </div>
          </div>
          <div>
            <label style={labelStyle}>Property Type</label>
            <select value={newTenant.property_type} onChange={e => setNewTenant(s => ({ ...s, property_type: e.target.value }))} style={inputStyle}>
              {["House", "Triplex - Unit 1", "Triplex - Unit 2", "Triplex - Unit 3", "Duplex - Unit 1", "Duplex - Unit 2", "Apartment", "Other"].map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label style={labelStyle}>Status</label>
            <select value={newTenant.status} onChange={e => setNewTenant(s => ({ ...s, status: e.target.value }))} style={inputStyle}>
              <option value="active">Active</option>
              <option value="month-to-month">Month-to-Month</option>
              <option value="expiring">Expiring Soon</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Notes (optional)</label>
            <textarea value={newTenant.notes} onChange={e => setNewTenant(s => ({ ...s, notes: e.target.value }))} style={{ ...inputStyle, height: 72, resize: "vertical" }} placeholder="Anything to note about this tenant..." />
          </div>
          <div style={{ padding: "14px 16px", background: "#eef7f1", borderRadius: 10, border: "1px solid #c8e6c9" }}>
            <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
              <input type="checkbox" checked={newTenant.is_complimentary} onChange={e => setNewTenant(s => ({ ...s, is_complimentary: e.target.checked }))} style={{ width: 16, height: 16, accentColor: "#163C2F" }} />
              <span style={{ fontWeight: 600, fontSize: 14, color: "#163C2F" }}>Complimentary tenant — no rent charged</span>
            </label>
            {newTenant.is_complimentary && (
              <div style={{ marginTop: 10 }}>
                <label style={labelStyle}>Complimentary Notes</label>
                <textarea value={newTenant.complimentary_notes} onChange={e => setNewTenant(s => ({ ...s, complimentary_notes: e.target.value }))} style={{ ...inputStyle, height: 60, resize: "vertical" }} placeholder="e.g. Rent free - pays own expenses except garbage" />
              </div>
            )}
          </div>
        </Modal>
      )}

      {/* Edit Tenant Modal */}
      {editTenant && (
        <Modal title="Edit Tenant" onClose={() => setEditTenant(null)} onSave={saveTenantEdit}>
          {[["Full Name", "name", "text", ""], ["Address", "address", "text", ""], ["City", "city", "text", ""], ["State", "state", "text", ""], ["Zip", "zip", "text", ""], ["Unit/Property Label", "property", "text", ""], ["Email", "email", "email", ""], ["Phone", "phone", "text", ""], ["Lease Start", "lease_start", "date", ""], ["Monthly Rent", "rent", "number", ""]].map(([label, key, type, ph]) => (
            <div key={key}>
              <label style={labelStyle}>{label}</label>
              <input type={type} placeholder={ph} value={editTenant[key] || ""} onChange={e => setEditTenant(s => ({ ...s, [key]: e.target.value }))} style={inputStyle} />
            </div>
          ))}
          <div>
            <label style={labelStyle}>Lease End — leave blank for month-to-month</label>
            <input type="date" value={editTenant.lease_end || ""} onChange={e => setEditTenant(s => ({ ...s, lease_end: e.target.value }))} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Property Type</label>
            <select value={editTenant.property_type || "House"} onChange={e => setEditTenant(s => ({ ...s, property_type: e.target.value }))} style={inputStyle}>
              {["House", "Triplex - Unit 1", "Triplex - Unit 2", "Triplex - Unit 3", "Duplex - Unit 1", "Duplex - Unit 2", "Apartment", "Other"].map(c => <option key={c}>{c}</option>)}
            </select>
          </div>
          <div>
            <label style={labelStyle}>Status</label>
            <select value={editTenant.status || "active"} onChange={e => setEditTenant(s => ({ ...s, status: e.target.value }))} style={inputStyle}>
              <option value="active">Active</option>
              <option value="month-to-month">Month-to-Month</option>
              <option value="expiring">Expiring Soon</option>
            </select>
          </div>
          <div>
            <label style={labelStyle}>Notes (optional)</label>
            <textarea value={editTenant.notes || ""} onChange={e => setEditTenant(s => ({ ...s, notes: e.target.value }))} style={{ ...inputStyle, height: 72, resize: "vertical" }} />
          </div>
          <div style={{ padding: "14px 16px", background: "#eef7f1", borderRadius: 10, border: "1px solid #c8e6c9" }}>
            <label style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}>
              <input type="checkbox" checked={editTenant.is_complimentary || false} onChange={e => setEditTenant(s => ({ ...s, is_complimentary: e.target.checked }))} style={{ width: 16, height: 16, accentColor: "#163C2F" }} />
              <span style={{ fontWeight: 600, fontSize: 14, color: "#163C2F" }}>Complimentary tenant — no rent charged</span>
            </label>
            {editTenant.is_complimentary && (
              <div style={{ marginTop: 10 }}>
                <label style={labelStyle}>Complimentary Notes</label>
                <textarea value={editTenant.complimentary_notes || ""} onChange={e => setEditTenant(s => ({ ...s, complimentary_notes: e.target.value }))} style={{ ...inputStyle, height: 60, resize: "vertical" }} placeholder="e.g. Rent free - pays own expenses except garbage" />
              </div>
            )}
          </div>
        </Modal>
      )}

      {/* Tenant Payment History Modal */}
      {showTenantHistory && (
        <Modal title={`Payment History — ${showTenantHistory.name}`} onClose={() => setShowTenantHistory(null)}>
          {payments.filter(p => p.tenant === showTenantHistory.name).length === 0
            ? <div style={{ color: "#9B9690", fontSize: 13 }}>No payments recorded for this tenant yet.</div>
            : <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr style={{ borderBottom: "1px solid #e0dbd0" }}>{["Date Paid","Amount","Late Fee","Method","Status"].map(h => <th key={h} style={{ padding: "8px 0", textAlign: "left", fontSize: 11, color: "#9B9690", fontFamily: "'Manrope', sans-serif", textTransform: "uppercase" }}>{h}</th>)}</tr></thead>
                <tbody>{payments.filter(p => p.tenant === showTenantHistory.name).map((p, i) => (
                  <tr key={i} style={{ borderBottom: "1px solid #e0dbd0" }}>
                    <td style={{ padding: "10px 0", fontSize: 13, color: "#9B9690" }}>{p.paid || "—"}</td>
                    <td style={{ padding: "10px 0", fontFamily: "'Manrope', sans-serif", fontWeight: 700 }}>${p.amount?.toLocaleString()}</td>
                    <td style={{ padding: "10px 0", color: p.late_fee ? "#ef4444" : "#9B9690" }}>{p.late_fee ? `$${p.late_fee}` : "—"}</td>
                    <td style={{ padding: "10px 0" }}>{p.payment_method || "—"}</td>
                    <td style={{ padding: "10px 0" }}><Badge label={p.status} color={statusColor[p.status] || "#8b949e"} /></td>
                  </tr>
                ))}</tbody>
              </table>}
          <div style={{ marginTop: 12, padding: "12px 16px", background: "#F5F1EA", borderRadius: 8 }}>
            <span style={{ fontWeight: 700 }}>Total Paid: </span>
            <span style={{ color: "#22c55e", fontFamily: "'Manrope', sans-serif", fontWeight: 700 }}>${payments.filter(p => p.tenant === showTenantHistory.name && p.status === "paid").reduce((s, p) => s + (p.amount || 0), 0).toLocaleString()}</span>
          </div>
        </Modal>
      )}
    </>
  );
}
